<script>
    export default {
        name: 'CheckboxGroup',

        props: {
            options: {
                type: Array,
                required: true,
            },
            value: {
                type: [String, Number, Boolean],
                required: false,
                default: '',
            },
        },

        methods: {
            optionSelected(key) {
                this.$emit('click', key);
                this.$emit('input', key);
            },
        },
    };
</script>

<template>
    <div class="checkbox-group">
        <div
            v-for="option in options"
            :key="option.key"
            class="checkbox-group__item"
            :class="{
        'checkbox-group__item--selected': option.key == value,
        [option.status ? option.status : 'bg-primary']: option.key == value,
      }"
            @click="optionSelected(option.key)"
        >
            {{ option.value }}
        </div>
    </div>
</template>
